import React from 'react';
import SvgIconContainer from '../SvgIconContainer';

export default function IconArrowBack(props) {
  return (
    <SvgIconContainer {...props}>
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="currentColor"
        fillRule="nonzero"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          cliprule="evenodd"
          d="M7.88316 1.23224C7.83326 1.11109 7.75417 1.00415 7.65294 0.92096C7.55172 0.837766 7.43149 0.780895 7.30296 0.75541C7.17443 0.729925 7.0416 0.736617 6.91629 0.774891C6.79097 0.813164 6.67707 0.881831 6.58471 0.974777L0.227571 7.33192C0.153568 7.40574 0.0948563 7.49342 0.0547962 7.58997C0.0147362 7.68651 -0.00588417 7.79 -0.00588417 7.89453C-0.00588417 7.99905 0.0147362 8.10255 0.0547962 8.19909C0.0948563 8.29563 0.153568 8.38332 0.227571 8.45713L6.58471 14.8143C6.73393 14.9635 6.9363 15.0473 7.14732 15.0473C7.35834 15.0473 7.56072 14.9635 7.70993 14.8143C7.85914 14.6651 7.94297 14.4627 7.94297 14.2517C7.94297 14.0407 7.85914 13.8383 7.70993 13.6891L2.70845 8.68917H19.8616C20.0724 8.68917 20.2745 8.60545 20.4235 8.45642C20.5725 8.3074 20.6562 8.10528 20.6562 7.89453C20.6562 7.68377 20.5725 7.48165 20.4235 7.33263C20.2745 7.18361 20.0724 7.09988 19.8616 7.09988H2.70845L7.70993 2.09999C7.82158 1.98882 7.89766 1.84697 7.9285 1.69246C7.95935 1.53795 7.94357 1.37776 7.88316 1.23224Z"
        />
      </svg>
    </SvgIconContainer>
  );
}

IconArrowBack.propTypes = SvgIconContainer.propTypes;
